import React from "react";

import { useRouteMatch, Switch, Route } from "react-router-dom";
import { PlantsView } from "../components/PlantsView";

export const PlantRoutes = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route path={`${path}/:field`}>
                <PlantsView />
            </Route>
            <Route path={`${path}`}>
                <PlantsView />
            </Route>
        </Switch>
    );
}
